import { render, staticRenderFns } from "./envio.vue?vue&type=template&id=25cf7448"
import script from "./envio.vue?vue&type=script&lang=js"
export * from "./envio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports